import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { getStaticCustomComponents } from './get-static-custom-components.js'
import { getStaticUiComponents } from './get-static-ui-components.js'
import { hasIntegration } from './has-integration.js'
import { hasPreset } from './has-preset.js'
import { TEMPLATE_REGISTRY } from './template-registry.js'
export function getAllComponentNamesForConfig(config: ResolvedBetterstartConfig): string[] {
  const staticUi = getStaticUiComponents()
  const staticCustom = getStaticCustomComponents()
  const templateKeys = Object.entries(TEMPLATE_REGISTRY)
    .filter(
      ([, entry]) =>
        (!entry.requiredPreset || hasPreset(config, entry.requiredPreset)) &&
        (!entry.requiredIntegration || hasIntegration(config, entry.requiredIntegration))
    )
    .map(([name]) => name)

  return [...new Set([...staticUi, ...staticCustom, ...templateKeys, 'tiptap'])].sort()
}
